// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"e7a3e81b90a33d85f1a7","655":"3334b93f92b5c7b428f2"}[chunkId] + ".js";
};